import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import SubmitButton from '../../../components/form/formComponents/SubmitButton';
import Form from '../../../components/form/Form';
import TextArea from '../../../components/form/formComponents/TextArea';
import FadeIn from '../../../components/FadeIn';

export default class DescriptionForm extends React.Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        onSave: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        mode: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        text: PropTypes.string,
        help: PropTypes.string,
        maxLength: PropTypes.number,
        header: PropTypes.string,
    };

    render() {
        return (
            <Form onValidSubmit={this.props.onSave}>
                <h2>{this.props.header}</h2>
                <FadeIn>
                    <div>
                        <TextArea
                            classes="input input--textarea"
                            id="description_textarea"
                            label={this.props.help}
                            maxLength={this.props.maxLength}
                            name="description"
                            required
                            rows="3"
                            validationErrorMsg={i18n['Required field']}
                            validations="exists"
                            value={this.props.text}
                        />
                        <div className="u-mb16">
                            <SubmitButton
                                className="button--cta u-mr16"
                                mode={this.props.mode}
                                value={i18n['Save button']}
                            />
                            <button
                                className="button"
                                onClick={this.props.onCancel}
                            >
                                {i18n['Cancel button']}
                            </button>
                        </div>
                    </div>
                </FadeIn>
            </Form>
        );
    }
}
